<template>
	<div class="container login_page" @click="handlePageClick">
		<!-- 顶部logo -->
		<div class="toper">
			<i class="logo"></i><span class="version">v2.0</span>
		</div>
		<!-- 顶部logo end-->
		<!-- 11 -->
		<!-- 22 -->
		<div v-loading="loading" class="main_box">
			<!-- 中间的表单部分 -->
			<div class="form_wrapper">
				<i class="cloud"></i>
				<p class="welcome">欢迎登录科飞云<span class="version">v2.0</span></p>

				<div class="inp_row" style="margin-top: 40px;">
					<div class="inp_row_left">
						<i class="icon_code"></i>
					</div>
					<input ref="code" v-model="code" :data-target="'codeInput'" type="text" placeholder="账号"
						@focus="handleCodeFocus" />
					<div v-show="cacheShow"
						style="box-sizing: content-box;position: absolute;z-index: 29;width: 100%;top: 45px;left: -1px;border: 1px solid #ccc;background: #ffe7e7;">
						<div v-for="(v, i) in cacheCode" :key="i"
							style="display: block;padding: 0 10px;font-size: 16px;color: #666;line-height: 44px;cursor: pointer;"
							:data-target="'cache'" :data-index="i">{{ v.code }}</div>
					</div>
				</div>
				<div class="base_tip" style="width: 360px;"><template v-if="codeTipDisplay"><i
							class="b_icon"></i>{{ codeTipText }}</template></div>

				<div class="inp_row">
					<div class="inp_row_left">
						<i class="icon_pwd"></i>
					</div>
					<input ref="password" v-model="password" type="password" placeholder="密码" />
				</div>
				<div class="base_tip" style="width: 360px;"><template v-if="passwordTipDisplay"><i
							class="b_icon"></i>{{ passwordTipText }}</template></div>

				<div class="funcs clear_both">
					<el-checkbox v-model="isAutoLogin" style="float: left;">下次自动登录</el-checkbox>
					<a class="funcs_right" @click="navigateToResetPassword">忘记密码</a>
				</div>

				<button class="login_btn" @click="handleLoginBtnClick">登 录</button>
			</div>
			<!-- 中间的表单部分 end-->

			<!-- 底部 -->
			<div class="ft">
				<p>Copyright © 2016 合肥科飞视觉科技有限公司</p>
				<p>科飞视觉 版权所有 皖ICP备13017400号-1</p>
			</div>
			<!-- 底部 end -->
		</div>
	</div>
</template>

<script>
	import Api from "../../api/index.js"
	import Login from "../../assets/js/login.js"
	import Cookies from 'js-cookie'
	import {
		mapMutations
	} from "vuex"
	import Config from '../../assets/js/config.js'
//  17368861136
	var Loading = null;
	export default {
		data() {
			return {
				loading: false,
				cacheCode: [],
				cacheShow: false,
				code: "",
				password: "",
				codeTipDisplay: false,
				codeTipText: "",
				passwordTipDisplay: false,
				passwordTipText: "",
				isAutoLogin: true,
				autoValidate: false
			}
		},
		mounted() {
			this.listenInput();
		},
		methods: {
			/********************* @Ajax *************************/
			// 获取产品类型
			findProductType() {
				const that = this;
				Loading = that.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				var _requestData = {};
				Api.findProductType(_requestData).then((res) => {
					if (res.data.success) {
						let products = [];
						let mission = [];
						let mission_ids = [];
						res.data.data.forEach((v) => {
							var _isBe = false;
							products.forEach((fv) => {
								if (fv.id == v.productId) {
									_isBe = true;
									v.missionId && fv.child.push({
										missionId: v.missionId,
										missionName: v.missionName
									});
								}
							});
							!_isBe && products.push({
								id: v.productId,
								name: v.productName,
								child: v.missionId ? [{
										missionId: v.missionId,
										missionName: v.missionName
									}] :
									[]
							});
							mission_ids.indexOf(v.missionId) == -1 &&
								mission.push({
									id: v.missionId,
									name: v.missionName
								});
							mission_ids.indexOf(v.missionId) == -1 && mission_ids.push(v.missionId);
						});
						// console.log(_list);
						that.setAllProduct(products);
						that.setMission(mission);
						that.findAuthProduct();
					} else {
						Loading.close();
						that.$message.error(res.data.message);
					}
				}, (e) => {
					Loading.close();
					that.$message.error(e.message);
				});
			},
			// 获取登录者产品
			findAuthProduct() {
				const that = this;
				var _requestData = {};
				Api.findAuthProduct(_requestData).then((res) => {
					if (res.data.success) {
						var _list = [];
						res.data.data && res.data.data.forEach((v) => {
							_list.push({
								id: v.productId,
								name: v.productName
							});
						});
						// console.log(_list);
						that.setAuthProduct(_list);
						that.findAllDisease();
					} else {
						Loading.close();
						that.$message.error(res.data.message);
					}
				}, (e) => {
					Loading.close();
					that.$message.error(e.message);
				});
			},
			// 获取病理类型
			findAllDisease() {
				const that = this;
				var _requestData = {};
				Api.findAllDisease(_requestData).then((res) => {
					if (res.data.success) {
						var _list = [];
						res.data.data.forEach((v) => {
							_list.push({
								id: v.uid,
								name: v.uname
							});
						});
						that.setAllDisease(_list);
						that.findPermission();
					} else {
						Loading.close();
						that.$message.error(res.data.message);
					}
				}, (e) => {
					Loading.close();
					that.$message.error(e.message);
				});
			},
			// 获取权限列表
			findPermission() {
				const that = this;
				Api.findPermission().then((res) => {
					if (res.data.success) {
						let res_list = res.data.data || [];
						let list = [];
						res_list.forEach((v) => {
							list.push({
								id: v.privilegeId,
								name: v.privilegeName,
								url: v.privilegeUrl
							});
						});
						that.setAllPermission(list);
						that.findAppManager();
					} else {
						Loading.close();
						that.$message.error(res.data.message);
					}
				}, (e) => {
					Loading.close();
					that.$message.error(e.message);
				});
			},
			// 获取app商务经理
			findAppManager() {
				const that = this;
				Api.findPermission().then((res) => {
					if (res.data.success) {
						let res_list = res.data.data || [];
						let list = [];
						res_list.forEach((v) => {
							list.push({
								id: v.uId,
								name: v.uName,
								mobile: v.uPhone
							});
						});
						that.setAppManager(list);
						that.findOrganizations();
					} else {
						Loading.close();
						that.$message.error(res.data.message);
					}
				}, (e) => {
					Loading.close();
					that.$message.error(e.message);
				});
			},
			// 获取机构
			findOrganizations() {
				const that = this;
				Api.findOrganizations().then((res) => {
					if (res.data.success) {
						let res_list = res.data.data || [];
						let list = [];
						res_list.forEach((v) => {
							list.push({
								id: v.uId,
								name: v.uName
							});
						});
						that.setAllOrganization(list);
						that.findAppArticlePublisher();
					} else {
						Loading.close();
						that.$message.error(res.data.message);
					}
				}, (e) => {
					Loading.close();
					that.$message.error(e.message);
				});
			},
			// 获取app文章发布人
			findAppArticlePublisher() {
				const that = this;
				Api.findAppArticlePublisher().then((res) => {
					if (res.data.success) {
						let res_list = res.data.data || [];
						let list = [];
						res_list.forEach((v) => {
							list.push({
								id: v.uId,
								name: v.uName,
								oid: v.uEnterpriseId
							});
						});
						that.setAppArticlePublisher(list);
						that.findTrainingProductForApp();
					} else {
						Loading.close();
						that.$message.error(res.data.message);
					}
				}, (e) => {
					Loading.close();
					that.$message.error(e.message);
				});
			},
			// 获取app训练产品列表
			findTrainingProductForApp() {
				const that = this;
				Api.findTrainingProductForAppAndMall({
					typeChannel: 1
				}).then((res) => {
					if (res.data.success) {
						let res_list = res.data.data || [];
						let list = [];
						res_list.forEach((v) => {
							list.push({
								id: v.productId,
								name: v.productName
							});
						});
						that.setAppTrainingProduct(list);
						that.findTrainingProductForMall();
					} else {
						Loading.close();
						that.$message.error(res.data.message);
					}
				}, (e) => {
					Loading.close();
					that.$message.error(e.message);
				});
			},
			// 获取商城训练产品列表
			findTrainingProductForMall() {
				const that = this;
				Api.findTrainingProductForAppAndMall({
					typeChannel: 2
				}).then((res) => {
					if (res.data.success) {
						let res_list = res.data.data || [];
						let list = [];
						res_list.forEach((v) => {
							list.push({
								id: v.productId,
								name: v.productName
							});
						});
						that.setMallTrainingProduct(list);
						Loading.close();
						that.$router.replace({
							path: '/index'
						});
					} else {
						Loading.close();
						that.$message.error(res.data.message);
					}
				}, (e) => {
					Loading.close();
					that.$message.error(e.message);
				});
			},

			/********************* @Listener *************************/
			// input监听
			listenInput() {
				const that = this;
				this.$refs.code.addEventListener("focus", () => {
					var _parentEle = this.$refs.code.parentNode;
					_parentEle.style.border = "1px solid #bb9ab0";
				}, false);
				this.$refs.password.addEventListener("focus", () => {
					var _parentEle = this.$refs.password.parentNode;
					_parentEle.style.border = "1px solid #bb9ab0";
				}, false);
				this.$refs.code.addEventListener("blur", () => {
					var _parentEle = this.$refs.code.parentNode;
					_parentEle.style.border = "1px solid #d7d7d7";
				}, false);
				this.$refs.password.addEventListener("blur", () => {
					var _parentEle = this.$refs.password.parentNode;
					_parentEle.style.border = "1px solid #d7d7d7";
				}, false);
				this.$refs.code.addEventListener("input", () => {
					that.autoValidate && that.validateCode();
				}, false);
				this.$refs.password.addEventListener("input", () => {
					that.autoValidate && that.validatePassword();
				}, false);
			},
			/********************* @Events *************************/
			handlePageClick(e) {
				const that = this;
				var _target = e.target.dataset.target;
				if (!_target) {
					that.cacheShow = false;
				} else if (_target == "cache") {
					var _index = parseInt(e.target.dataset.index),
						_code = that.cacheCode[_index].code,
						_password = that.cacheCode[_index].password;
					that.code = _code;
					that.password = _password;
					that.validateCode();
					that.$nextTick(() => {
						that.cacheShow = false;
					});
				}
			},
			handleCodeFocus() {
				this.renderCache();
			},
			// 点击忘记密码
			navigateToResetPassword() {
				this.$router.push({
					path: "/reset_password"
				});
			},
			// 点击登录按钮
			handleLoginBtnClick() {
				const that = this;
				that.autoValidate = true;
				if (!that.validateCode()) {
					return false;
				}
				if (!that.validatePassword()) {
					return false;
				}
				that.loading = true;
				var _requestData = {
					username: that.code,
					password: that.password,
					type: 'backstage',
					grant_type: 'password'
				};
				Api.login(_requestData).then((res) => {
					if (res.data.success) {
						console.log(res);
						var _kj = res.data.data.access_token,
							_kt = res.data.data.jti;
						Login.setSafeInfo(_kj, _kt);
						that.isAutoLogin && that.setCache(that.code, that.password);
						Login.setLoginInfo(that.code);
						localStorage.setItem('card_enterprise',res.data.data.card_enterprise)
						
						Login.setSafeInfoCache(_kj, _kt);
						Login.setLoginInfoCache(that.code);
						var _requestData = {
							uCode: that.code,
							type: 'b'
						};
						Api.findUserInfo(_requestData).then((rt) => {
							that.loading = false;
							if (rt.data.success) {
								console.log(rt);
								that.setAuthInfo(rt.data.data);
								that.$message({
									message: rt.data.message,
									type: 'success'
								});
								that.findProductType();
							} else {
								Login.exit();
								that.$message.error(rt.data.message);
							}
						}, (e) => {
							// Login.exit();
							that.loading = false;
							that.$message.error(e.message);
						});
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			/********************* @Function *************************/
			// 验证账号
			validateCode() {
				if (this.code) {
					this.codeTipDisplay = false;
					this.codeTipText = "";
					return true;
				} else {
					this.codeTipDisplay = true;
					this.codeTipText = "请输入账号";
					return false;
				}
			},
			// 验证密码
			validatePassword() {
				if (this.password) {
					this.passwordTipDisplay = false;
					this.passwordTipText = "";
					return true;
				} else {
					this.passwordTipDisplay = true;
					this.passwordTipText = "请输入密码";
					return false;
				}
			},
			// 设置缓存
			setCache(code, password) {
				var _c = [];
				var _s = false;
				Cookies.get("kfCloudAdmin_loginList") && (_c = JSON.parse(Cookies.get("kfCloudAdmin_loginList")));
				_c.forEach(v => {
					if (code == v.code) {
						_s = true;
					}
				});
				!_s && (_c = [{
					code: code,
					password: password
				}, ..._c]);
				if (_c.length) {
					_c.length > 6 && _c.pop();
					Cookies.set("kfCloudAdmin_loginList", JSON.stringify(_c), {
						expires: Config.cookie_expires
					})
				} else {
					Cookies.remove("kfCloudAdmin_loginList");
				}
			},
			// 渲染缓存
			renderCache() {
				var _c = [];
				Cookies.get("kfCloudAdmin_loginList") && (_c = JSON.parse(Cookies.get("kfCloudAdmin_loginList")));
				this.cacheCode = _c;
				this.cacheCode.length && (this.cacheShow = true);
			},

			...mapMutations({
				'setAuthInfo': 'setAuthInfo',
				'setAllProduct': 'setAllProduct',
				'setMission': 'setMission',
				'setAuthProduct': 'setAuthProduct',
				'setAllDisease': 'setAllDisease',
				'setAllPermission': 'setAllPermission',
				'setAllOrganization': 'setAllOrganization',
				'setAppManager': 'setAppManager',
				'setAppArticlePublisher': 'setAppArticlePublisher',
				'setAppTrainingProduct': 'setAppTrainingProduct',
				'setMallTrainingProduct': 'setMallTrainingProduct'
			})
		}
	}
</script>

<style scoped>
	.login_page {
		background-image: url(../../assets/images/body_bg.png);
		background-attachment: fixed;
	}

	.login_page .toper {
		display: block;
		position: fixed;
		z-index: 99;
		width: 100%;
		min-width: 1200px;
		height: 62px;
		top: 0;
		left: 0;
		padding: 0 40px;
		border: 1px solid #e4e4e3;
		background-color: #fff;
		box-shadow: 2px 2px 2px rgba(13, 4, 8, 0.05);
	}

	.login_page .toper .logo {
		display: inline-block;
		width: 105px;
		height: 21px;
		margin-top: 20px;
		background-image: url("../../assets/images/kefy.png");
		vertical-align: top;
	}

	.login_page .toper .version {
		display: inline-block;
		margin: 25px 0 0 10px;
		font-size: 16px;
		color: #505050;
		vertical-align: top;
	}

	.login_page .main_box {
		position: relative;
		min-height: 100%;
		padding: 62px 0 120px 0;
		overflow-y: auto;
		overflow-x: hidden;
	}

	.login_page .form_wrapper {
		width: 500px;
		height: 560px;
		margin: 40px auto 0;
		padding: 50px 0 0 0;
		border-radius: 6px;
		border: 1px solid #e4e4e3;
		box-shadow: 2px 2px 20px 8px rgba(13, 4, 8, 0.1);
		background-color: #fff;
	}

	.login_page .form_wrapper .cloud {
		display: block;
		width: 124px;
		height: 82px;
		margin: 0 auto;
		background-image: url(../../assets/images/ufly_cloud.png);
	}

	.login_page .form_wrapper .welcome {
		margin-top: 15px;
		font-size: 20px;
		color: #505050;
		text-align: center;
	}

	.login_page .form_wrapper .inp_row {
		position: relative;
		width: 360px;
		height: 46px;
		margin: 0 auto;
		padding: 0 0 0 48px;
		border: 1px solid #d7d7d7;
		background: #ffe7e7;
		font-size: 0;
	}

	.form_wrapper .inp_row_left {
		display: block;
		position: absolute;
		z-index: 9;
		width: 48px;
		height: 44px;
		top: 0;
		left: 0;
		padding: 10px 0 0 0;
		border-right: 1px solid #d7d7d7;
		background: #eee;
		text-align: center;
	}

	.login_page .form_wrapper .icon_code {
		display: inline-block;
		width: 24px;
		height: 24px;
		background-image: url(../../assets/images/login/code.png);
		background-size: 100% 100%;
		vertical-align: top;
	}

	.login_page .form_wrapper .icon_pwd {
		display: inline-block;
		width: 24px;
		height: 24px;
		background-image: url(../../assets/images/login/pwd.png);
		background-size: 100% 100%;
		vertical-align: top;
	}

	.login_page .form_wrapper .inp_row input {
		display: block;
		width: 100%;
		padding: 0 10px;
		background: transparent;
		font-size: 16px;
		line-height: 44px;
	}

	.login_page .form_wrapper .funcs {
		display: block;
		width: 360px;
		margin: 0 auto;
		font-size: 14px;
		color: #409eff;
		line-height: 24px;
	}

	.login_page .form_wrapper .funcs_right {
		display: block;
		float: right;
	}

	.login_page .form_wrapper .login_btn {
		display: block;
		width: 240px;
		height: 50px;
		margin: 40px auto 0;
		background-image: url(../../assets/images/login/dl.png);
		background-size: 100% 100%;
		color: #fff;
		font-size: 18px;
		cursor: pointer;
	}

	.login_page .ft {
		position: absolute;
		width: 700px;
		height: 80px;
		bottom: 30px;
		left: 50%;
		margin-left: -350px;
		padding: 24px 0 0 0;
		border-top: 1px solid #e0e0e0;
		font-size: 12px;
		color: #b1b1b1;
		text-align: center;
		line-height: 22px;
	}
</style>